import React, { Component } from 'react';

export default class EmptyMatchmakingTabComponent extends Component {
	render() {
		return (
			<div className='panel no_matches'>
				<h4 className='center-block'>{this.props.children}</h4>
			</div>
		);
	}

}